'use client';
var serializeHeaders = function(headers) {
    var serialized = {};
    headers.forEach(function(value, key) {
        serialized[key] = value;
    });
    return serialized;
};

export { serializeHeaders };
